var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitchText(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 27,
    viewBox: "0 0 89 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.38959 1.96912H1.30957V0.869141H8.76959V1.96912H5.68958V11.0592H4.38959V1.96912Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.79 0.869141H12.1301L13.2001 6.40918C13.4001 7.49918 13.6 8.59921 13.8 9.68921H13.86C14.09 8.59921 14.3301 7.48918 14.5801 6.40918L15.9901 0.869141H17.17L18.5801 6.40918C18.8301 7.48918 19.0701 8.58921 19.3201 9.68921H19.3801C19.5801 8.58921 19.76 7.48918 19.96 6.40918L21.03 0.869141H22.28L20.17 11.0592H18.61L17.0701 4.93921C16.9001 4.14921 16.7301 3.39914 16.5801 2.61914H16.5201C16.3601 3.39914 16.1901 4.13921 16.0101 4.93921L14.5001 11.0592H12.96L10.8 0.869141H10.79Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2598 0.869141H26.5598V11.0592H25.2598V0.869141Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7001 1.96912H29.6201V0.869141H37.0801V1.96912H34.0001V11.0592H32.7001V1.96912Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1797 5.9696C39.1797 2.6796 41.1197 0.679688 43.6997 0.679688C44.9397 0.679688 45.9097 1.2797 46.4997 1.9397L45.7897 2.77966C45.2497 2.20966 44.5797 1.8197 43.7197 1.8197C41.7997 1.8197 40.5197 3.39969 40.5197 5.92969C40.5197 8.45969 41.7397 10.0996 43.6697 10.0996C44.6397 10.0996 45.3797 9.67959 46.0297 8.95959L46.7397 9.76965C45.9397 10.7097 44.9397 11.2396 43.6197 11.2396C41.0797 11.2396 39.1797 9.2796 39.1797 5.9696Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8701 0.869141H51.1701V5.13916H55.9101V0.869141H57.2101V11.0592H55.9101V6.26917H51.1701V11.0592H49.8701V0.869141Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitchText);
export default __webpack_public_path__ + "static/media/twitch-text.1be753905ba8479033093a3c9226580a.svg";
export { ForwardRef as ReactComponent };